/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import Img from 'modules/common/components/Img';

import * as actions from '../action';

function Requirements({ tabList }) {
  const [requirementTab, setRequirementTab] = useState(0);

  const handleChangeRequirementTab = location => () => {
    setRequirementTab(location);
  };

  return (
    <React.Fragment>
      <div className="row mb-3 d-flex align-items-center">
        <div className="col py-0">
          <h3 className="m-0">Requirements</h3>
        </div>
      </div>
      <div className="row mb-3">
        {/* TABS */}
        <div className="col-6">
          <div className="form-wrapper arrow-card">
            {!_.isEmpty(tabList) ? (
              tabList.map((item, i) => (
                <div
                  key={item.id}
                  role="presentation"
                  className="arrow-cell p-3 btn-blank"
                  onClick={handleChangeRequirementTab(i)}
                >
                  <div className="font-weight-bold">
                    {_.get(item, 'attributes._application_requirement')}
                  </div>
                  {i === requirementTab ? <div className="arrow" /> : ''}
                </div>
              ))
            ) : '' }
          </div>
        </div>
        {/* IMAGE HOLDER */}
        <div className="col-6">
          <div className="form-wrapper preview-image">
            {!_.isEmpty(tabList) // CHECK TABLIST IF EMPTY
              ? (
                <React.Fragment>
                  {tabList.map((item, i) => ( // MAP AND CHECK IF ITEM IS EQUAL TO ACTIVE TAB
                    i === requirementTab ? (
                      <Img
                        key={item.id}
                        src={_.get(item, 'attributes.url')}
                        className="shadow-lg"
                        role="presentation"
                        defaultSrc={defaultPhoto}
                        width="80%"
                        alt=""
                      />
                    ) : ''
                  ))}
                </React.Fragment>
              ) : ''
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

Requirements.propTypes = {
  tabList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(Requirements);
